import { Modal } from 'react-bootstrap';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 35px 30px 30px;
  gap: 16px;

  @media (max-width: 768px) {
    margin-bottom: 100px;
    padding: 20px 16px;
  }
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  padding: 22px 35px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;

  @media (max-width: 768px) {
    text-align: center;
    padding: 19px 13px;
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  line-height: 37px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.blue};
  margin: 0;
`;

export const Subtitle = styled.h2`
  font-size: 16px;
  line-height: 25px;
  color: ${({ theme }) => theme.colors.gray};
  margin: 0;
`;

export const Divider = styled.div`
  height: 1px;
  border-top: 1px dashed rgba(0, 0, 0, 0.2);
  margin: 15px -35px;

  @media (max-width: 768px) {
    margin: 15px -13px;
  }
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  & + div {
    margin-top: 8px;
  }

  & > svg {
    color: #ead414;
    min-height: 25px;
    min-width: 25px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

type InfoTextProps = {
  bold?: boolean;
};
export const InfoText = styled.span<InfoTextProps>`
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.blue};

  ${({ bold }) =>
    bold &&
    css`
      font-weight: bold;
    `}

  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 18.5px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 22px 35px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 19px 13px;
  }
`;

export const ContentHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > button {
    height: 35px;
    padding: 0 20px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;

    & > button {
      height: inherit;
    }
  }
`;

type TableWrapProps = {
  showTour?: boolean;
};

export const TableWrap = styled.div<TableWrapProps>`
  position: relative;

  ${({ showTour }) =>
    showTour &&
    css`
      z-index: 1000;
      background-color: #f5f5f5;
      padding: 2px;
      border-radius: 8px;
    `}
`;

export const ContentTitle = styled.h3`
  font-size: 16px;
  line-height: 25px;
  color: ${({ theme }) => theme.colors.blue};
  margin: 0;
`;

export const NotFound = styled.span`
  font-size: 16px;
  line-height: 25px;
  color: #828282;
  text-align: center;
  margin: 15px 0;
`;

export const Items = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 15px 24px;
  background-color: #e6eaf0;
  border-radius: 8px;
  height: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ItemTitle = styled.span`
  font-size: 16px;
  line-height: 25px;
  font-family: 'Mangueira Bold';
  color: ${({ theme }) => theme.colors.blue};
  min-width: 130px;
`;

export const ItemDivider = styled.div`
  height: 30px;
  width: 1px;
  border-left: 1px dashed rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    height: 1px;
    width: 100%;
    border-top: 1px dashed rgba(0, 0, 0, 0.2);
  }
`;

export const ContainerLabels = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
`;

export const LabelContent = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

export const Label = styled.span`
  font-size: 12px;
  line-height: 19px;
  font-family: 'Mangueira Bold';
  color: ${({ theme }) => theme.colors.blue};
`;

export const Value = styled.a`
  font-size: 16px;
  line-height: 25px;
  color: #828282;

  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 19px;
  }
`;

export const ModalStyled = styled(Modal)`
  & .modal-dialog {
    max-width: 550px;
    width: 100%;
  }

  & .modal-content {
    display: flex;
    flex-direction: column;
    padding: 25px 40px;
    width: 100%;

    @media (max-width: 768px) {
      padding: 25px;
    }
  }
`;
